import { render, staticRenderFns } from "./CollectionSelect.vue?vue&type=template&id=15a24f2e&scoped=true&"
import script from "./CollectionSelect.vue?vue&type=script&lang=js&"
export * from "./CollectionSelect.vue?vue&type=script&lang=js&"
import style0 from "./CollectionSelect.vue?vue&type=style&index=0&id=15a24f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a24f2e",
  null
  
)

export default component.exports